// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3K2KS","vLegacy":"SelectSecondary_vLegacy__3O3Qm","error":"SelectSecondary_error__3Wjrk","disabled":"SelectSecondary_disabled__3-b5t"};